import enterprise from './enterprise.js'
import account from './account.js'
import role from './role'

export default {
    enterprise: enterprise,
    account: account,
    role
}
